export default {
  // Page metadata
  'meta.title': 'Условия обслуживания - timer.today',
  'meta.description': 'Условия обслуживания и пользовательское соглашение для платформы онлайн инструментов хронометража timer.today. Узнайте о наших правилах обслуживания, правах и обязанностях пользователей.',

  // Page header
  'page.title': 'Условия обслуживания',
  'page.lastUpdated': 'Последнее обновление: {{date}}',
  'page.intro': 'Добро пожаловать на timer.today. Эти условия описывают правила и положения по использованию веб-сайта timer.today, расположенного по адресу timer.today.',

  // Section 1
  'section1.title': '1. Принятие условий',
  'section1.content': 'Получая доступ к этому веб-сайту и используя его, вы принимаете и соглашаетесь соблюдать условия и положения данного соглашения. Если вы не согласны соблюдать вышеизложенное, пожалуйста, не используйте этот сервис.',

  // Section 2
  'section2.title': '2. Описание сервиса',
  'section2.intro': 'timer.today предоставляет бесплатные онлайн инструменты хронометража, включая:',
  'section2.timer': 'Таймер обратного отсчета - Настраиваемый таймер для продуктивности, готовки и управления временем',
  'section2.stopwatch': 'Секундомер - Высокоточный инструмент хронометража для спорта, тренировок и точного хронометража',
  'section2.worldclock': 'Мировые часы - Отображение в реальном времени глобальных часовых поясов',

  // Section 3
  'section3.title': '3. Лицензия на использование',
  'section3.intro': 'Разрешается временное использование timer.today только для личного, некоммерческого временного просмотра. Это предоставление лицензии, а не передача права собственности, и в соответствии с этой лицензией вы не можете:',
  'section3.item1': 'изменять или копировать материалы',
  'section3.item2': 'использовать материалы в коммерческих целях или для публичного показа',
  'section3.item3': 'пытаться выполнить обратную разработку любого программного обеспечения, содержащегося на веб-сайте',
  'section3.item4': 'удалять любые авторские права или другие проприетарные обозначения из материалов',

  // Section 4
  'section4.title': '4. Конфиденциальность и данные',
  'section4.intro': 'timer.today стремится защитить вашу конфиденциальность:',
  'section4.item1': 'Мы не собираем и не храним личную информацию',
  'section4.item2': 'Настройки таймера хранятся локально в вашем браузере',
  'section4.item3': 'Мы не отслеживаем поведение пользователей или шаблоны использования',
  'section4.item4': 'Файлы cookie не используются для целей отслеживания',

  // Section 5
  'section5.title': '5. Отказ от ответственности',
  'section5.content': 'Материалы на timer.today предоставляются "как есть". timer.today не дает никаких гарантий, явных или подразумеваемых, и настоящим отказывается и отрицает все другие гарантии, включая, без ограничений, подразумеваемые гарантии или условия товарной пригодности, пригодности для конкретной цели или ненарушения интеллектуальной собственности или другого нарушения прав.',

  // Section 6
  'section6.title': '6. Ограничения',
  'section6.content': 'Ни при каких обстоятельствах timer.today или его поставщики не несут ответственности за любой ущерб (включая, без ограничений, ущерб от потери данных или прибыли, или из-за прерывания бизнеса), возникший в результате использования или невозможности использования материалов на timer.today, даже если timer.today или его уполномоченный представитель был уведомлен устно или письменно о возможности такого ущерба.',

  // Section 7
  'section7.title': '7. Точность материалов',
  'section7.content': 'Материалы, появляющиеся на timer.today, могут содержать технические, типографские или фотографические ошибки. timer.today не гарантирует, что какие-либо материалы на его веб-сайте являются точными, полными или актуальными. timer.today может вносить изменения в материалы, содержащиеся на его веб-сайте, в любое время без уведомления.',

  // Section 8
  'section8.title': '8. Изменения',
  'section8.content': 'timer.today может пересмотреть эти условия обслуживания для своего веб-сайта в любое время без уведомления. Используя этот веб-сайт, вы соглашаетесь соблюдать текущую версию этих условий обслуживания.',

  // Section 9
  'section9.title': '9. Контактная информация',
  'section9.intro': 'Если у вас есть какие-либо вопросы об этих Условиях обслуживания, пожалуйста, свяжитесь с нами:',
  'section9.email': 'Электронная почта:',
  'section9.emailSubject': 'Запрос об Условиях обслуживания - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. Все права защищены.'
};